/**
 * @fileoverview gRPC-Web generated client stub for usergroup
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: usergroup/usergroup.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.usergroup = require('./usergroup_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.usergroup.UserGroupServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.usergroup.UserGroupServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.usergroup.UserGroups>}
 */
const methodDescriptor_UserGroupService_List = new grpc.web.MethodDescriptor(
  '/usergroup.UserGroupService/List',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.usergroup.UserGroups,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usergroup.UserGroups.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.usergroup.UserGroups)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usergroup.UserGroups>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usergroup.UserGroupServiceClient.prototype.list =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usergroup.UserGroupService/List',
      request,
      metadata || {},
      methodDescriptor_UserGroupService_List,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usergroup.UserGroups>}
 *     Promise that resolves to the response
 */
proto.usergroup.UserGroupServicePromiseClient.prototype.list =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usergroup.UserGroupService/List',
      request,
      metadata || {},
      methodDescriptor_UserGroupService_List);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usergroup.UserGroupRecord,
 *   !proto.usergroup.UserGroupRecord>}
 */
const methodDescriptor_UserGroupService_Create = new grpc.web.MethodDescriptor(
  '/usergroup.UserGroupService/Create',
  grpc.web.MethodType.UNARY,
  proto.usergroup.UserGroupRecord,
  proto.usergroup.UserGroupRecord,
  /**
   * @param {!proto.usergroup.UserGroupRecord} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usergroup.UserGroupRecord.deserializeBinary
);


/**
 * @param {!proto.usergroup.UserGroupRecord} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.usergroup.UserGroupRecord)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usergroup.UserGroupRecord>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usergroup.UserGroupServiceClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usergroup.UserGroupService/Create',
      request,
      metadata || {},
      methodDescriptor_UserGroupService_Create,
      callback);
};


/**
 * @param {!proto.usergroup.UserGroupRecord} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usergroup.UserGroupRecord>}
 *     Promise that resolves to the response
 */
proto.usergroup.UserGroupServicePromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usergroup.UserGroupService/Create',
      request,
      metadata || {},
      methodDescriptor_UserGroupService_Create);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usergroup.UserGroupRecord,
 *   !proto.usergroup.UserGroupRecord>}
 */
const methodDescriptor_UserGroupService_Update = new grpc.web.MethodDescriptor(
  '/usergroup.UserGroupService/Update',
  grpc.web.MethodType.UNARY,
  proto.usergroup.UserGroupRecord,
  proto.usergroup.UserGroupRecord,
  /**
   * @param {!proto.usergroup.UserGroupRecord} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usergroup.UserGroupRecord.deserializeBinary
);


/**
 * @param {!proto.usergroup.UserGroupRecord} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.usergroup.UserGroupRecord)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usergroup.UserGroupRecord>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usergroup.UserGroupServiceClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usergroup.UserGroupService/Update',
      request,
      metadata || {},
      methodDescriptor_UserGroupService_Update,
      callback);
};


/**
 * @param {!proto.usergroup.UserGroupRecord} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usergroup.UserGroupRecord>}
 *     Promise that resolves to the response
 */
proto.usergroup.UserGroupServicePromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usergroup.UserGroupService/Update',
      request,
      metadata || {},
      methodDescriptor_UserGroupService_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usergroup.UserGroupID,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_UserGroupService_Delete = new grpc.web.MethodDescriptor(
  '/usergroup.UserGroupService/Delete',
  grpc.web.MethodType.UNARY,
  proto.usergroup.UserGroupID,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usergroup.UserGroupID} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.usergroup.UserGroupID} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usergroup.UserGroupServiceClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usergroup.UserGroupService/Delete',
      request,
      metadata || {},
      methodDescriptor_UserGroupService_Delete,
      callback);
};


/**
 * @param {!proto.usergroup.UserGroupID} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.usergroup.UserGroupServicePromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usergroup.UserGroupService/Delete',
      request,
      metadata || {},
      methodDescriptor_UserGroupService_Delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usergroup.UpdateUserGroupMembershipsRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_UserGroupService_UpdateUserGroupMemberships = new grpc.web.MethodDescriptor(
  '/usergroup.UserGroupService/UpdateUserGroupMemberships',
  grpc.web.MethodType.UNARY,
  proto.usergroup.UpdateUserGroupMembershipsRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usergroup.UpdateUserGroupMembershipsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.usergroup.UpdateUserGroupMembershipsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usergroup.UserGroupServiceClient.prototype.updateUserGroupMemberships =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usergroup.UserGroupService/UpdateUserGroupMemberships',
      request,
      metadata || {},
      methodDescriptor_UserGroupService_UpdateUserGroupMemberships,
      callback);
};


/**
 * @param {!proto.usergroup.UpdateUserGroupMembershipsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.usergroup.UserGroupServicePromiseClient.prototype.updateUserGroupMemberships =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usergroup.UserGroupService/UpdateUserGroupMemberships',
      request,
      metadata || {},
      methodDescriptor_UserGroupService_UpdateUserGroupMemberships);
};


module.exports = proto.usergroup;

